import { initFileUploaders } from "./FileUploader";

interface RepeatElement extends HTMLElement {
    _cmsTemplateRepeatInited?: boolean;
}

function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function renumber(root: HTMLElement): void {
    const name = root.dataset.repeatName ?? "";
    const label = root.dataset.repeatLabel ?? name;
    if (name === "") return;

    const pattern = new RegExp(`\\[${escapeRegExp(name)}\\]\\[(?:\\d+|__INDEX__)\\]`);
    root.querySelectorAll<HTMLElement>("[data-cms-template-repeat-item]").forEach((item, index) => {
        item.dataset.repeatIndex = String(index);
        item.querySelector<HTMLElement>("[data-cms-template-repeat-title]")?.replaceChildren(`${label} ${index + 1}`);
        item.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>("[name]").forEach((field) => {
            field.name = field.name.replace(pattern, `[${name}][${index}]`);
        });
    });
}

function addItem(root: HTMLElement): void {
    const template = root.querySelector<HTMLTemplateElement>("[data-cms-template-repeat-template]");
    const list = root.querySelector<HTMLElement>("[data-cms-template-repeat-list]");
    if (!template || !list) return;

    const index = list.querySelectorAll("[data-cms-template-repeat-item]").length;
    const html = template.innerHTML.replace(/__INDEX__/g, String(index));
    const wrap = document.createElement("div");
    wrap.innerHTML = html.trim();
    const item = wrap.firstElementChild as HTMLElement | null;
    if (!item) return;

    list.appendChild(item);
    renumber(root);
    initFileUploaders();
}

function moveItem(root: HTMLElement, item: HTMLElement, direction: "up" | "down"): void {
    const list = root.querySelector<HTMLElement>("[data-cms-template-repeat-list]");
    if (!list) return;
    if (direction === "up" && item.previousElementSibling) {
        list.insertBefore(item, item.previousElementSibling);
    }
    if (direction === "down" && item.nextElementSibling) {
        list.insertBefore(item.nextElementSibling, item);
    }
    renumber(root);
}

export function initCmsTemplateRepeats(scope: Document | HTMLElement = document): void {
    scope.querySelectorAll<RepeatElement>("[data-cms-template-repeat]").forEach((root) => {
        if (root._cmsTemplateRepeatInited) return;
        root._cmsTemplateRepeatInited = true;

        root.addEventListener("click", (event) => {
            const target = event.target as HTMLElement | null;
            const add = target?.closest<HTMLElement>("[data-cms-template-repeat-add]");
            if (add && root.contains(add)) {
                event.preventDefault();
                addItem(root);
                return;
            }

            const item = target?.closest<HTMLElement>("[data-cms-template-repeat-item]");
            if (!item || !root.contains(item)) return;

            const remove = target?.closest<HTMLElement>("[data-cms-template-repeat-remove]");
            if (remove) {
                event.preventDefault();
                item.remove();
                renumber(root);
                return;
            }

            const up = target?.closest<HTMLElement>("[data-cms-template-repeat-up]");
            if (up) {
                event.preventDefault();
                moveItem(root, item, "up");
                return;
            }

            const down = target?.closest<HTMLElement>("[data-cms-template-repeat-down]");
            if (down) {
                event.preventDefault();
                moveItem(root, item, "down");
            }
        });

        renumber(root);
    });
}
